import { TranslateService } from '@ngx-translate/core';
import { isAfter, isBefore, isWithinInterval } from 'date-fns';
import { Extension } from "ng2-adsk-forge-viewer";
// import { Fragment } from 'src/app/interfaces/api/fragment';
// import { Metric } from 'src/app/interfaces/api/metric';
import { effect, Injector, runInInjectionContext, signal, WritableSignal } from '@angular/core';
import { PlanningTools } from 'src/app/classes/planning/planning-tools';
import * as Tools from 'src/app/classes/shared/threeDTools';
import { ForgeTools } from 'src/app/classes/viewer/forge-tools';
import { MetricObject } from 'src/app/classes/viewer/objects/MetricObject';
import { Fragment, FragmentObject } from 'src/app/interfaces/api/fragment';
import { Metric } from 'src/app/interfaces/api/metric';
import { PlanningTask } from 'src/app/interfaces/api/task';
import { Config } from 'src/app/interfaces/shared/config';
import { MetricService } from 'src/app/services/api/metrics/metric.service';
import { PlanningService } from 'src/app/services/api/plannings/planning.service';
import { TrackService } from 'src/app/services/api/tracks/track.service';
import { PlanningStore } from 'src/app/services/stores/planning.store';
// import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
// import { Font } from 'three/examples/jsm/loaders/FontLoader.js';
import { Cursor } from '../Cursor';
import { PlanningExtension } from '../planning-model/extension';
// import * as THREE from 'three';

const THREE = (globalThis as any).THREE;


export class MetricExtension extends Extension {
    //main
    public static override extensionName: string = 'MetricExtension';
    public mainPanel: any = null;
    public subToolbar: Autodesk.Viewing.UI.ControlGroup | null = null;
    public zones: Record<string, any> = {};
    public model: any = null;
    public toolName = "Autodesk.ADN.Viewing.Tool.MetricExtension";
    declare viewer: Autodesk.Viewing.GuiViewer3D;

    translate: TranslateService = {} as TranslateService;
    planningService: PlanningService = {} as PlanningService;
    planningStore: PlanningStore = {} as PlanningStore;
    metricService: MetricService = {} as MetricService;
    trackService: TrackService = {} as TrackService;
    injector!: Injector;

    //inputs
    selectedFragIds: string[] = [];
    fragIds: number[] = [];
    tasks: PlanningTask[] = [];
    selectedTasks!: WritableSignal<PlanningTask[]>;
    selectedFragments!: WritableSignal<Fragment[]>;
    selectedMetrics!: Metric[];
    selectedDay: WritableSignal<string> = signal<string>("");
    context: string = "planning";

    metrics: Metric[] = [];
    fragments: Fragment[] = [];
    currentMetric: Metric | null = null;
    currentTask: PlanningTask | null = null;
    currentFragments: Fragment[] = [];

    public onPlanningReady: any;
    public onMetricsLoaded: any;
    public onImageClick: any;
    private toolbarCreatedListener!: () => void;
    public onLinkMetric: any;
    public taskName: string = '';
    public task: PlanningTask | null = null;
    public startDate: string = '';
    public endDate: string = '';
    public currentDate: string = '';
    public planningExt!: PlanningExtension;
    fragmentObjectMaterial: THREE.Material = {} as THREE.Material;
    uploadingFragments: boolean = false;
    rebuildFragments: boolean = false;
    scaleDivider: number = 25;
    is2d: boolean = false;
    fragmentObjects: THREE.Object3D[] = [];
    zoneMeshes: Record<string, any> = {};
    realtime: boolean = false;
    public planning: string = ''; //planning id
    fragIndex: Record<string, number> = {}//fragid:index in array
    taskIndex: Record<string, number> = {}//taskId:index in array
    metricObjects: MetricObject[] = [];
    metricByIds: Record<string, Metric> = {};
    metricObjectByIds: Record<string, MetricObject> = {};
    craneCycles: THREE.Mesh[] = [];
    concretings: any[] = [];
    concretingPhases: THREE.Mesh[] = [];
    colors = Config.colors;
    cursor: Cursor | null = null;
    metricById: Record<string, number> = {};
    unit: string = '';
    unitName: string = '';
    selectedMetric: string = '';
    metricSelected: boolean = false;
    tracksSubscription: any;
    textures: Record<string, THREE.Texture | null> = {
        reinforcement: null,
        precast_slab: null,
        formwork: null,
        concreting: null,
        column: null,
        beam: null,
        wall: null,
        other: null,
    };
    materialKeys = [
        "reinforcement",
        "precast_slab",
        "formwork",
        "concreting",
        "column",
        "beam",
        "wall",
        "other"
    ];

    forgeTools!: ForgeTools;
    planningTool = new PlanningTools();
    isolate = false;

    public async init(params: any) {
        Object.assign(this, params);
        this.fragments = [];
        this.fragIndex = {};
        this.selectedFragIds = [];

        this.fragmentObjectMaterial = new THREE.MeshPhongMaterial({
            name: "fragmentObjectMaterial",
            side: THREE.DoubleSide,
            color: '#010101'
        })

        this.forgeTools = new ForgeTools(this.viewer)
        let textures = await this.forgeTools.loadTextures(this.materialKeys);

        textures.forEach(t => {
            this.textures[t.name] = t;
        })

        this.initOverlay();

        runInInjectionContext(this.injector, () => {
            // 👁️ Select multiple metrics view
            effect(() => {
                this.selectedMetrics = this.planningStore.selectedMetrics();
                let startDate = this.selectedMetrics[0]?.payload?.startDate;
                let endDate = this.selectedMetrics[this.selectedMetrics.length - 1]?.payload.startDate

                if (startDate && endDate) {
                    this.startDate = startDate;
                    this.endDate = endDate;
                }

                let ids = this.selectedMetrics.map(m => m.id);

                if (this.context === "planning") {
                    this.selectMetricObjectByIds(ids);
                } else {
                    this.selectDayMetricsForDashboard(ids);
                }
            });

            // 📦 Load all fragments data
            effect(() => {
                this.fragments = this.planningStore.fragments();
            });

            // 📋 Update current task info
            effect(() => {
                this.currentTask = this.planningStore.currentTask();
                this.currentFragments = this.planningStore.getFragmentsByIds(this.currentTask?.fragments ?? []);
                this.planningStore.selectMetrics([]);
            });

            // 🏗️ Build metric 3D objects
            effect(() => {
                this.metricObjects.forEach(m => {
                    if (m.mesh) {
                        m.mesh.visible = false;
                        this.viewer.impl.removeOverlay("metrics", m.mesh);
                    }

                    if (m.tracePath) {
                        m.tracePath.visible = false;
                        this.viewer.impl.removeOverlay("metrics", m.tracePath);
                    }
                });

                this.metrics = this.planningStore.metrics();
                this.metricObjects = [];

                this.metrics.forEach(m => {
                    const position = {
                        lat: m.payload.lat ?? this.model.origin.lat,
                        lon: m.payload.lon ?? this.model.origin.lon,
                        z: m.payload.z ?? 0
                    }

                    const category = this.planningTool.getMetricIcon(m.payload['prediction'] ?? "")
                    m.payload['groupKey'] = category;
                    let dynamicColor: string = "";

                    if (this.context === "planning") {
                        dynamicColor = this.getColorByGroupKey(category, m.payload.color);
                    } else {
                        dynamicColor = m.payload.color ?? "";
                    }

                    let mo = new MetricObject(m, this.viewer, this.model,
                        {
                            name: "metric_" + m.id,
                            texture: this.textures[category],
                            position: Tools.applyTransform2(position, this.model.origin, this.model.offset),
                            color: dynamicColor
                        })

                    mo.mesh.visible = false;
                    this.metricObjectByIds[m.id] = mo;
                    this.metricObjects.push(mo);
                })

                this.enableCursor();
                this.invalidateViewer();
                this.viewer.impl.sceneUpdated(true);
            });

            // 📅 Apply date filtering visibility
            effect(() => {
                const currentDate = this.planningStore.currentDate();

                if (currentDate) {
                    this.currentDate = currentDate;

                    // If a current task, only display metrics of the task 
                    if (this.currentTask) {
                        const taskId = this.currentTask.id;

                        this.metricObjects.forEach(m => {
                            if (m.mesh) {
                                m.mesh.visible = m.metric.payload["taskId"] === taskId;
                            }
                        });

                        this.invalidateViewer();
                    } else {
                        this.setMetricAtDate(currentDate);
                    }
                }
            });

            // 🔗 Link fragment to metrics
            effect(() => {
                let fragments = this.planningStore.selectedFragments();

                if (this.context === "dashboard") return;

                if (fragments.length == 1) {
                    let metrics: string[] = [];

                    fragments.forEach((f: Fragment) => {
                        f.objects?.forEach((o: any) => {
                            if (o['metric'])
                                metrics.push(o['metric']);
                        });
                    });

                    this.planningStore.selectMetrics(this.metrics.filter(m => metrics.includes((m.payload as any)?.metric || '') || metrics.includes(m.id)).map(m => ({ ...m })))
                }
            })
        });

        this.viewer.registerContextMenuCallback('DisplayMetrics', (menu: any[], status: any) => { // Context menu types not fully available
            let metricVisible = this.metricObjects.find(mo => mo.mesh?.visible)

            if (metricVisible) {
                menu.push({
                    title: this.translate.instant('planning.hide_metrics'),
                    target: () => {
                        this.metricObjects.forEach((m: MetricObject) => {
                            if (m.mesh)
                                m.mesh.visible = false;
                        })
                    }
                });
            } else {
                menu.push({
                    title: this.translate.instant('planning.show_metrics'),
                    target: () => {
                        if (this.metrics[0]?.payload?.startDate) {
                            this.setMetricAtDate(this.currentDate)
                        }
                    }
                });
            }
        });

        this.viewer.registerContextMenuCallback('ShowRelatedMetric', (menu: any[], status: any) => { // Context menu types not fully available
            this.selectedFragIds = this.viewer.getSelection().map(id => id.toString());

            if (this.viewer.getSelectionCount())
                menu.push({
                    title: this.translate.instant('planning.show_related_metrics'),
                    target: () => {
                        let fragments = this.planningStore.selectedFragments();
                        let metrics: string[] = [];

                        fragments.forEach((f: Fragment) => {
                            f.objects?.forEach((o: any) => {
                                if (o['metric']) metrics.push(o['metric']);
                            });
                        });

                        this.planningStore.selectMetrics(this.metrics.filter(m => metrics.includes((m.payload as any)?.metric || '') || metrics.includes(m.id)).map(m => ({ ...m })))
                    }
                });
        });

        this.viewer.registerContextMenuCallback('ShowMetricPath', (menu: any[], status: any) => { // Context menu types not fully available
            this.selectedFragIds = this.viewer.getSelection().map(id => id.toString());

            if (this.viewer.getSelectionCount())
                menu.push({
                    title: this.translate.instant('planning.show_metrics_path'),
                    target: () => {
                        let fragments = this.planningStore.selectedFragments();
                        let metrics: string[] = [];

                        fragments.forEach((f: Fragment) => {
                            f.objects?.forEach((o: any) => {
                                if (o['metric']) metrics.push(o['metric']);
                            });
                        });

                        this.planningStore.selectMetrics(this.metrics.filter(m => metrics.includes((m.payload as any)?.metric || '') || metrics.includes(m.id)).map(m => ({ ...m })))
                    }
                });
        });
        // this.animate();
    }

    getMetricMesh(id: string): MetricObject | undefined {
        return this.metricObjects.find(m => m.metric.id == id)
    }

    getMaterialType(tag: string): string {
        let key = "other"

        if (tag.includes("coulage")) {
            key = "concreting";
        } else if (tag.includes("banche")) {
            key = "formwork";
        } else if (tag == "prédalle") {
            key = "precast_slab";
        } else if (tag.includes("armature")) {
            key = "reinforcement";
        } else if (tag.includes("prémur")) {
            key = "wall";
        } else if (tag.includes("poutre")) {
            key = "beam";
        } else if (tag.includes("poteau")) {
            key = "column";
        }

        return key
    }

    // setMetrics() {
    //     this.metricObjects = this.metrics.map((m: Metric) => {
    //         const materialType = this.getMaterialType(m.payload['prediction'].toLowerCase());
    //         const material = this.materials[materialType] as THREE.MeshPhongMaterial;
    //         const texture = this.textures[materialType] || null;
    //         return new MetricObject(m, this.viewer, this.model, { material, texture });
    //     })
    //     this.metricById = {};
    //     this.metricObjects.forEach((m: MetricObject, i: number) => {
    //         this.metricById[m.metric.id] = i;
    //     })
    //     // this.updateFragments();
    //     this.enableCursor();
    //     this.viewer.impl.invalidate(true, true, true);
    //     this.viewer.impl.sceneUpdated(true);
    // }

    getMetrics() {
        // let craneCycleQuery: any = { name: "Coup de grue", limit: 100000 };
        // let concretingQuery: any = { name: "Coulage", limit: 100000 };
        // let phaseQuery: any = { name: "Phase de grue", title: "Coulage", limit: 100000 };
        // if (this.unitName) {
        //     craneCycleQuery.unitName = this.unitName;
        //     concretingQuery.unitName = this.unitName;
        //     phaseQuery.unitName = this.unitName;
        // }

        // if (this.unit) {
        //     craneCycleQuery.unit = this.unit;
        //     concretingQuery.unit = this.unit;
        //     phaseQuery.unit = this.unit;
        // }

        // console.time("getMetrics")
        // this.metricService.getPlanningMetrics({ planning: this.planning }).subscribe(metrics => {
        //     this.metricObjects = metrics.map(m => new THREE.Mesh(m, this.viewer, this.model, this.materials[this.getMaterialType(m.payload.title.toLowerCase())] ))
        //     this.metricById = {};
        //     this.metricObjects.forEach((m, i) => {
        //         this.metricById[m.id] = i;
        //     })
        //     this.updateFragments();
        //     this.enableCursor()
        //     console.timeEnd("getMetrics")
        // })
    }

    setMetricAtDate(currentDate: string) {
        this.clearTracePaths();
        this.clearSelection();

        const displayMetric = this.planningStore.displayMetric();
        const tasks = this.planningStore.tasks();
        const currentDateObj = new Date(currentDate);

        const activeTaskIds = new Set<string>(
            tasks.filter(t =>
                t.startDate && t.endDate &&
                !isBefore(currentDateObj, new Date(t.startDate)) &&
                !isAfter(currentDateObj, new Date(t.endDate))
            ).map(t => t.id)
        );

        this.metricObjects.forEach((m: MetricObject) => {
            if (!m.mesh) return;

            const groupKey = m.metric.payload['groupKey'] ?? '';
            const isDisplayed = displayMetric[groupKey] ?? false;

            if (!isDisplayed) {
                m.mesh.visible = false;
                return;
            }

            const taskId = m.metric.payload['taskId'];
            m.mesh.visible = !!taskId && activeTaskIds.has(taskId);
        });

        this.invalidateViewer();
    }

    enableCursor() {
        if (this.cursor) {
            this.viewer.toolController.deregisterTool(this.cursor);
            this.cursor = null;
        }

        let cursorOptions = { objects: this.metricObjects, viewer: this.viewer }
        this.cursor = new Cursor(cursorOptions);
        this.viewer.toolController.registerTool(this.cursor);
        this.viewer.toolController.activateTool(this.cursor.toolName);

        this.cursor.selection.subscribe((selections: any[]) => {
            let mesh = selections[0];

            if (mesh && mesh.name.includes("metric_")) {
                this.planningStore.selectMetrics(this.planningStore.getMetricsByIds([mesh.name.split("_")[1]]));
            } else {
                this.planningStore.selectMetrics([]);
            }
        })
    }

    getLastchildren(id: number): number[] {
        let children: number[] = [];
        const findChild = (current: number) => {
            let currentChildren: number[] = []

            this.fragments.forEach((f: Fragment) => {
                if (f.parent == current) currentChildren.push(f.dbId!);
            })

            if (currentChildren.length) {
                currentChildren.forEach((cf: number) => {
                    findChild(cf)
                })
            } else {
                children.push(current)
            }
        }

        findChild(id)
        return children;
    }

    getSelection() {
        if (this.metricSelected) return;

        let ids = this.viewer.getSelection();
        let childIds: number[] = []

        ids.forEach((dbId: number) => {
            let children = this.getLastchildren(dbId)
            childIds = childIds.concat(children)
        });

        if (!childIds.length)
            childIds = ids;

        let frags: Fragment[] = [];
        let metrics: MetricObject[] = [];

        this.fragments.forEach(async (f: Fragment, i: number) => {
            if (childIds.includes(f.dbId!)) {
                frags.push(f);

                if (f.objects && f.objects.length) {
                    f.objects.forEach((o: FragmentObject) => {
                        if (!o.metric) {
                            let metric = this.getMetricByDate(o.createdDate as string);

                            if (metric) {
                                metrics.push(metric)
                                o.metric = metric.id;
                            }
                        }

                        if (o.metric) {
                            let mIndex = this.metricById[o.metric];

                            if (mIndex !== undefined && mIndex >= 0 && this.metricObjects[mIndex]) {
                                metrics.push(this.metricObjects[mIndex])
                            }
                        }
                    })
                }
            }

            return f;
        })

        if (frags.length) {
            this.selectedFragments.set(frags);
        }

        if (metrics.length && metrics.length > 1 && !this.selectedMetric) {
            this.selectedMetrics = metrics.map((m) => m.metric);
            this.selectMetricObjects(metrics);
        } else if (!this.selectedMetric) {
            this.selectMetricObjects([])
        }
    }

    onSelectMetric(mesh: any) {
        this.metricObjects.forEach(m => {
            m.update({ selected: false })

            if (m.tracePath)
                m.tracePath.visible = false;
        })

        if (!mesh) return;

        let metric = this.metricObjects.find(m => m.metric.id == mesh.metricId)

        if (metric) {
            this.getMetricPath(metric)
            let parents = this.getPastRelatedMetric(metric, [], this.metricObjects.length);

            if (parents && parents.length)
                parents.forEach((m) => {
                    let visible = this.planningStore.displayMetric()[m.metric.payload['groupKey'] ?? ""] ?? false;
                    m.update({ color: "dark", visible, selected: visible })
                    this.getMetricPath(m)
                })

            metric.update({ selected: true })
        }
    }

    getMetricPath(mo: MetricObject) {
        if (!mo.tracePath) {
            if (mo.tracker && mo.startDate && mo.endDate)
                this.tracksSubscription = this.trackService.getTracks({ tracker: mo.tracker, startDate: mo.startDate, endDate: mo.endDate, limit: 3600 }).subscribe((res: any) => {
                    mo.buildTrace(res)
                })
        } else {
            mo.tracePath.visible = true
        }
    }

    getPastRelatedMetric(metric: MetricObject, parents: MetricObject[], lastIndex: number): MetricObject[] | null {
        if (!metric.weight || !metric.mesh || !metric.loadPosition) return null;

        let parent: MetricObject | undefined;
        let position = metric.loadPosition;
        let minWeight = metric.weight - metric.weight * 0.1;
        let maxWeight = metric.weight + metric.weight * 0.1;
        let prevDist = Infinity;

        for (let i = 0; i < this.metricObjects.length; i++) {
            let m = this.metricObjects[i];

            if (!m) continue;

            if (isBefore(new Date(m.endDate!), new Date(metric.startDate!))) {
                if (m.title == metric.title && m.weight && m.weight > minWeight && m.weight < maxWeight) {
                    if (m.mesh) {
                        let dist = m.mesh.position.distanceTo(position);
                        dist /= this.model.origin.scale;

                        if (dist < 4 && dist < prevDist) {
                            parent = m;
                            prevDist = dist;
                            lastIndex = i - 1;
                        }
                    }
                }
            }

            if (i > lastIndex) break;
        }

        if (parent) {
            parents.push(parent)
            this.getPastRelatedMetric(parent, parents, lastIndex);
        }

        return parents;
    }

    getMetricByDate(date: string): MetricObject | undefined {
        return this.metricObjects.find((m) => isWithinInterval(
            new Date(date),
            {
                start: new Date(m.metric.payload.startDate!),
                end: new Date(m.metric.payload.endDate!)
            }));
    }

    selectMetricObjectByIds(metricIds: string[]) {
        this.clearTracePaths();
        this.clearSelection();

        if (!metricIds.length) {
            // CAS 1 : Task selected
            if (this.currentTask) {

                const taskId = this.currentTask.id;

                this.metricObjects.forEach(m => {
                    const isTaskMetric = m.metric.payload["taskId"] === taskId;

                    if (m.mesh) {
                        m.mesh.visible = isTaskMetric;
                    }
                });

                this.invalidateViewer();
                return;
            }

            // CAS 2 : Global date selected
            const dateToApply = this.currentDate || this.planningStore.currentDate();

            if (dateToApply) {
                this.currentDate = dateToApply;
                this.setMetricAtDate(dateToApply);
            } else {
                this.metricObjects.forEach(m => {
                    if (m.mesh) {
                        m.mesh.visible = false;
                    }
                });

                this.invalidateViewer();
            }

            return;
        }

        // CAS 3 : One or more specific metrics selected
        const displayMetric = this.planningStore.displayMetric();

        this.metricObjects.forEach((m) => {
            const groupKey = m.metric.payload["groupKey"] ?? "";
            const isSelected = metricIds.includes(m.id);

            const isVisible = (metricIds.length === 1 && isSelected) || (isSelected && (displayMetric[groupKey] ?? false));
            m.update({ selected: isSelected });

            if (m.mesh) {
                m.mesh.visible = isVisible;
            }

            if (isSelected && metricIds.length === 1) {
                if (m.tracePath) {
                    m.tracePath.visible = true;
                } else {
                    this.getMetricPath(m);
                }
            }
        });

        this.invalidateViewer();
    }

    selectMetricObjectById(metricId: string, isolate: boolean = false) {
        this.metricObjects.forEach((m) => {
            if (m.id != metricId) {
                if (m.color == "primary") {
                    m.update({ color: "danger" })
                }

                m.update({ selected: false })

                if (isolate)
                    if (m.mesh)
                        m.mesh.visible = false;
            } else {
                if (m.color !== "primary") {
                    m.update({ color: "primary" })
                }

                m.update({ selected: true })

                if (m.mesh)
                    m.mesh.visible = true;
            }
        })

        // let metricIndex = this.metricById[metricId]
        // this.metricObjects[metricIndex].update({ color: "primary", visible: true })
    }

    selectMetricObjects(metrics: MetricObject[]) {
        this.metricObjects.forEach((m) => {
            if (m.color == "primary") {
                m.update({ color: "danger", visible: false })
            }

            if (m.mesh)
                m.mesh.visible = false;
        })

        metrics.forEach((m) => {
            let visible = this.planningStore.displayMetric()[m.metric.payload['groupKey'] ?? ""] ?? false;
            m.update({ color: "primary", visible })

            if (m.mesh)
                m.mesh.visible = visible;
        })
    }

    selectDayMetricsForDashboard(dayMetricIds: string[]) {
        this.clearTracePaths();
        this.clearSelection();

        const dayMetricsSet = new Set(dayMetricIds);

        const updateMetricsVisibility = (visibleIds: Set<string>, shouldBeVisible: boolean) => {
            this.metricObjects.forEach(m => {
                if (m.mesh) {
                    m.mesh.visible = visibleIds.has(m.id) && shouldBeVisible;
                }
            });
        };

        this.metricObjects.forEach(m => {
            if (m.mesh) m.mesh.visible = false;
        });

        if (!dayMetricIds.length) {
            // CAS 1 : Show metrics of the day saved
            const savedDay = this.planningStore.selectedDay();

            if (savedDay) {
                updateMetricsVisibility(new Set(savedDay.split(',')), true);
                this.invalidateViewer();
                return;
            }

            // CAS 2 : First load to show latest day metrics
            let latestDayMetrics: MetricObject[] = [];
            let latestDate = '';

            this.metricObjects.reduce((map, m) => {
                const date = new Date(m.metric.payload.startDate ?? new Date());
                const endDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999).toISOString();

                if (!map.has(endDate)) map.set(endDate, []);
                const metrics = map.get(endDate)!;
                metrics.push(m);

                if (endDate > latestDate) {
                    latestDate = endDate;
                    latestDayMetrics = metrics;
                }

                return map;
            }, new Map<string, MetricObject[]>());

            if (latestDayMetrics.length > 0) {
                this.planningStore.selectMetrics(latestDayMetrics.map(m => m.metric));
                this.planningStore.setSelectedDay(latestDayMetrics.map(m => m.id).join(','));
                this.invalidateViewer();
                return;
            }

            // Fallback
            const taskIds = new Set(this.planningStore.tasks().map(t => t.id));

            this.metricObjects.forEach(m => {
                if (m.mesh) {
                    m.mesh.visible = taskIds.has(m.metric.payload["taskId"]);
                }
            });

            this.invalidateViewer();
            return;
        }

        // CAS 3 : One metric selected
        if (dayMetricIds.length === 1) {
            const selectedMetric = this.metricObjects.find(m => m.id === dayMetricsSet.keys().next().value);

            if (selectedMetric && selectedMetric.mesh) {
                selectedMetric.mesh.visible = true;
                selectedMetric.update({ selected: true });
                this.getMetricPath(selectedMetric);
            }

            this.invalidateViewer();
            return;
        }

        // CAS 4 : Metrics selected
        updateMetricsVisibility(dayMetricsSet, true);
        this.planningStore.setSelectedDay(dayMetricIds.join(','));
        this.invalidateViewer();
    }

    initOverlay() {
        try {
            if (!this.viewer.overlays.hasScene("metrics")) {
                this.viewer.overlays.addScene("metrics");
            }

            // Object.keys(this.materials).forEach(key => {
            //     this.viewer.impl.createOverlayScene("metric-" + key, this.materials[key]);
            // })

            Object.keys(this.colors).forEach(c => {
                let material: any = new THREE.MeshPhongMaterial({
                    color: this.colors[c]
                });

                this.viewer.impl.createOverlayScene(c, material);

                let lineMaterial = new THREE.LineBasicMaterial({
                    color: this.colors[c],
                    transparent: false,
                    linewidth: 10
                });

                this.viewer.impl.createOverlayScene('trace-' + c, lineMaterial as any);
            });
        } catch (e) {
            console.error(e)
        }
    }

    // getText(text: string) {
    //     let size = 0.4;

    //     let geom = new TextGeometry(text, {
    //         font: new Font(FontJson),
    //         size,
    //         depth: 0.05,
    //         curveSegments: 3,
    //     });
    //     geom.computeBoundingBox();
    //     if (geom.boundingBox) {
    //         geom.translate(geom.boundingBox.max.x * -0.5, 0.5, 0)
    //     }

    //     var mat = new THREE.MeshBasicMaterial({ color: "#000000" });

    //     let textMesh = new THREE.Mesh(geom, mat);
    //     if (this.viewer && !this.viewer.model.getData().is2d) {
    //         textMesh.rotateY(90 * Math.PI / 180);
    //         textMesh.rotateZ(90 * Math.PI / 180);
    //     } else {
    //         textMesh.rotateZ(-1 * this.model.origin.zAngle * Math.PI / 180);
    //     }
    //     textMesh.updateMatrix();
    //     return textMesh
    // }

    linkMetric(ids: any) { }

    public onTaskSelected() { }

    public activate() {
        return true;
    }

    public deactivate() {
        return true;
    }

    public load(): any {
        // this.viewer.addEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, () => {
        //     this.createUI();
        //     // this.loadTaskSelected();
        // })

        return true;
    }

    public unload(): any {
        this.fragments = [];
        this.selectedFragIds = [];
        this.metricObjects = [];
        this.metricById = {};

        if (this.viewer) {
            this.viewer.removeEventListener(Autodesk.Viewing.TOOLBAR_CREATED_EVENT, this.toolbarCreatedListener);
        }

        if (this.viewer.toolbar) {
            this.viewer.toolbar.removeControl(this.toolName);
        }

        if (this.cursor) {
            this.viewer.toolController.deregisterTool(this.cursor);
            this.cursor = null;
        }

        if (this.tracksSubscription) {
            this.tracksSubscription.unsubscribe();
            this.tracksSubscription = null;
        }

        return true;
    }

    public createUI() {
        // Toolbar button
        let button = new Autodesk.Viewing.UI.Button('metric-btn');
        button.onClick = () => this.onToolbarButtonClicked();
        button.addClass('metric-btn');
        button.setToolTip(this.translate.instant('planning.planning_tool'));
        button.setIcon('metric-btn-icon');
        button.onMouseOver = (e) => {
            button.setIcon('hover-metric-btn-icon');
        }

        button.onMouseOut = (e) => {
            button.setIcon('metric-btn-icon');
        }

        // SubToolbar
        this.subToolbar = this.viewer.toolbar.getControl('planning-toolbar') as Autodesk.Viewing.UI.ControlGroup | null
        if (!this.subToolbar) {
            this.subToolbar = new Autodesk.Viewing.UI.ControlGroup('planning-toolbar');
            this.viewer.toolbar.addControl(this.subToolbar);
        }
        this.subToolbar.addControl(button);
        this.viewer.toolbar.addControl(this.subToolbar);
    }

    onToolbarButtonClicked() {
        if (this.mainPanel != null) {
            this.mainPanel.uninitialize();
            this.mainPanel = null;
        } else {
            // this.mainPanel = new MetricDockingPanel(this.viewer, this.viewer.container, 'metricDockingPanel', 'metric', {
            //     translate: this.translate,
            //     planningService: this.planningService,
            //     onImageClick: this.onImageClick,
            //     showAll: () => this.selectMetrics(this.metricObjects),
            //     metrics: this.metricObjects,
            //     selectedFragments: this.selectedFragments,
            //     selectedMetrics: this.selectedMetrics(),
            //     selectedTasks: this.selectedTasks
            // });
        }
    }


    // event callbacks
    public onToolbarCreated() {
        // this.createUI();
    };

    animate() {
        if (!this.viewer || !this.viewer.impl) return;
        const camera: any = this.viewer.getCamera();

        this.fragmentObjects.forEach(frag => {

            let dist = frag.position.distanceTo(camera.position);
            let scale = 1;
            if (!this.is2d) {

                scale = dist / this.scaleDivider;

                if (scale < this.model.minUnitScale) return;

                let vector, angle;

                //get the normalized vector of the target
                let target = new THREE.Vector3(camera.position.x, camera.position.y, camera.position.z);
                vector = target.sub(frag.position);
                angle = Math.atan2(vector.y, vector.x);

                if (frag.children[0])
                    frag.children[0].rotation["y"] = angle + 1.57;

            } else {

                scale = camera.position.z / this.scaleDivider;
                // if (scale < this.model.minUnitScale) return;
            }
            // frag.rotation["z"] = angle;
            // frag.lookAt(new THREE.Vector3(camera.position.x, camera.position.y, 0));
            frag.scale.set(scale, scale, scale);
            frag.updateMatrix();
        })

        requestAnimationFrame(() => this.animate());
    }

    getColorByGroupKey(groupKey: string, baseColor?: string): string {
        const palette: Record<string, string> = {
            concreting: "#0099CC",
            formwork: "#F0C300",
            other: "#666666",
            reinforcement: "#388E3C",
            precast_slab: "#CC0000",
            wall: "#FF6600",
            beam: "#f56892",
            column: "#7B1FA2",
        };

        return palette[groupKey] || baseColor || "#666666";
    }

    /////////////
    // CLEANER //
    /////////////

    private clearTracePaths() {
        this.metricObjects.forEach(m => {
            if (m.tracePath) {
                m.tracePath.visible = false;
            }
        });
    }

    private clearSelection() {
        this.metricObjects.forEach(m => {
            m.update({ selected: false });

            if (m.mesh) {
                m.mesh.visible = false;
            }
        });
    }

    private invalidateViewer() {
        if (this.viewer?.impl) {
            this.viewer.impl.invalidate(true, true, true);
        }
    }
}